module.exports = __webpack_public_path__ + "2b6ddaae2f9ba95cb0c4129c3fb9af81-nei_grid_2x.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/leakRecognition/assets/nei_grid_2x.png
// module id = 688
// module chunks = 0